/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-undef */
import React from "react";
import {
  BsTwitter,
  BsGithub,
  BsLinkedin,
  BsFillCloudArrowDownFill,
} from "react-icons/bs";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a href="https://github.com/Cadium" target="_blank" rel="noreferrer">
          <BsGithub />
        </a>
      </div>
      <div>
        <a
          href="https://www.linkedin.com/in/oguntowokitan/"
          target="_blank"
          rel="noreferrer"
        >
          <BsLinkedin />
        </a>
      </div>
      <div>
        <a
          href="https://twitter.com/cadium_eth"
          target="_blank"
          rel="noreferrer"
        >
          <BsTwitter />
        </a>
      </div>
      <div>
        <a
          href="https://drive.google.com/file/d/1nBAQ4Ufe-7z9oxYTPu5GdunAgvfa7jya/view?usp=sharing"
          target="blank"
          rel="noreferrer"
        >
          <BsFillCloudArrowDownFill />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
